import { BASE_API_URL } from '@/constant/api'
import { axiosAuth } from 'Utils/axios'
import { AppResp } from 'Types/api'
import { TokenRes } from 'Types/auth'
import { getPlatform } from '@/utils/platform'

export const getNewToken = async () => {
  const res = await axiosAuth.post<AppResp<TokenRes>>(
    `${BASE_API_URL}/auth/refresh_token`
  )
  if (!res.data.data) {
    throw new Error('No token data')
  }
  return res.data.data.token
}

export const logout = async (platform = getPlatform()) => {
  await axiosAuth.post<AppResp<undefined>>(`${BASE_API_URL}/user/logout`, {
    platform,
  })
}
